import PerimeterConditions from './PerimeterConditions.vue';

const PerimeterConditionsRoutes = {
  path: 'perimeterconditions',
  name: 'diseases.perimeter_conditions',
  component: PerimeterConditions,
  meta: {
    prefix_permission: 'diseases_perimeterconditions',
  },
};

export default PerimeterConditionsRoutes;
